import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const RouteMiddleWare = (props: any) => {
  const { token, component: Component, path } = props;
  if (!token) {
    return <Component {...props} />;
  } else {
    return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
  }
};

function RedirectRoute({ component, ...rest }: any) {
  return (
    <Route
      {...rest}
      render={(props) => <RouteMiddleWare component={component} {...props} {...rest} />}
    />
  );
}

export default connect(({ auth: { token } }: any) => {
  return { token };
})(RedirectRoute);
